import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const IDLE_TIME = 15 * 60 * 1000;

export function useIdleLogout(logout: () => void, enabled: boolean = true) {
  const timer = useRef<NodeJS.Timeout | null>(null);

  const { pathname } = useLocation();

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);
    if (enabled) {
      timer.current = setTimeout(() => {
        logout();
      }, IDLE_TIME);
    }
  };

  useEffect(() => {
    if (!enabled) {
      // Clear any existing timer if disabled
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }

      return;
    }

    const events = ['click', 'mousemove', 'scroll', 'keydown', 'wheel'];

    events.forEach(e => window.addEventListener(e, resetTimer));

    resetTimer();

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      if (timer.current) clearTimeout(timer.current);
    };
  }, [pathname, enabled, logout]);
}
